{
  "name": "coreui-free-angular-admin-template",
  "version": "4.0.0-alpha.3",
  "config": {
    "coreui_library_short_version": "4.0",
    "coreui_library_docs_url": "https://coreui.io/angular/docs/"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration development",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "build-dev": "ng build -c development"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.4",
    "@angular/aria": "^22.1.4",
    "@angular/cdk": "^22.1.4",
    "@angular/common": "^22.1.4",
    "@angular/compiler": "^22.1.4",
    "@angular/core": "^22.1.4",
    "@angular/forms": "^22.1.4",
    "@angular/language-service": "^22.1.4",
    "@angular/platform-browser": "^22.1.4",
    "@angular/platform-browser-dynamic": "^22.1.4",
    "@angular/router": "^22.1.4",
    "@azure/msal-angular": "^6.2.0",
    "@azure/msal-browser": "^5.20.0",
    "@coreui/angular": "^5.7.23",
    "@coreui/angular-chartjs": "^5.7.23",
    "@coreui/chartjs": "^4.2.0",
    "@coreui/coreui": "5.9.0",
    "@coreui/icons": "^3.1.0",
    "@coreui/icons-angular": "^5.7.23",
    "@coreui/utils": "^2.0.2",
    "@primeuix/themes": "^2.0.3",
    "@types/crypto-js": "^4.2.2",
    "ag-grid-angular": "^36.1.0",
    "ag-grid-community": "^36.1.0",
    "boxicons": "^2.1.4",
    "chart.js": "^4.5.1",
    "crypto-js": "^4.2.0",
    "file-saver": "^2.0.5",
    "fs": "^0.0.1-security",
    "jszip": "^3.10.1",
    "jszip-utils": "^0.1.0",
    "moment": "^2.30.1",
    "ngx-scrollbar": "^19.1.5",
    "primeicons": "^8.0.0",
    "primeng": "^21.1.9",
    "rxjs": "~7.8.2",
    "secure-web-storage": "^1.0.2",
    "tslib": "^2.8.1",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
    "zone.js": "~0.16.2"
  },
  "devDependencies": {
    "@angular/build": "^22.1.6",
    "@angular/cli": "^22.1.6",
    "@angular/compiler-cli": "^22.1.4",
    "@angular/localize": "^22.1.4",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~6.0.0",
    "@types/node": "^24.13.3",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~7.0.2",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.3.0",
    "typescript": "~6.0.3"
  },
  "engines": {
    "node": "^22.22.3 || ^24.15.0 || >=26.0.0",
    "npm": ">= 10"
  },
  "browser": {
    "fs": false,
    "path": false,
    "Buffer": false
  },
  "overrides": {
    "@coreui/coreui": "5.9.0",
    "qs": ">=6.16.0"
  }
}
